import React from "react";
import { Typography } from "antd";
import { ERROR_700, ERROR_100 } from "../../constant/colors";
import { fontWeights, sizes } from "../../constant/styles";
import { useTranslation } from "react-i18next";
import { ReactComponent as AlertCircle } from "../../assets/svg/alert-circle.svg";

const { Text } = Typography;

export const Close = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <div
      {...props}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: ERROR_100,
        padding: "2px 8px",
        borderRadius: 4,
        gap: 5
      }}
    >
      <AlertCircle />

      <Text
        style={{
          fontSize: sizes.xsmall,
          fontWeight: fontWeights.semibold,
          color: ERROR_700,
          textTransform: "uppercase"
        }}
      >
        {t("patientPotentialSavings.closed")}
      </Text>
    </div>
  );
};
